import Post1 from "../../Attachments/Images/post-1.webp";
import Post2 from "../../Attachments/Images/post-2.webp";
import Post3 from "../../Attachments/Images/post-3.webp";
import Post4 from "../../Attachments/Images/post-4.webp";
import Post5 from "../../Attachments/Images/post-5.webp";
import Post6 from "../../Attachments/Images/post-6.webp";
import Post7 from "../../Attachments/Images/post-7.webp";
import Post8 from "../../Attachments/Images/post-8.webp";
import Post9 from "../../Attachments/Images/post-9.webp";
import Post10 from "../../Attachments/Images/post-10.webp";

const sectionDataID1 = {
  image: Post1,
  title:
    "Depresi, Insecurity, Rendah Diri, Emosi Berlebih, Bisa Dihilangkan Dengan Terapi Hypnosis",
  opening: (
    <>
      Ketika kamu membaca ini mungkin artikel ini memang ditakdirkan untuk kamu
      baca.
      <br />
      <br />
      Karena mungkin kamu sedang mengalami beberapa fase seperti yang tertulis
      pada judul di atas, atau ada keluarga, sahabat, rekan kerja atau teman
      yang mengalami fase tsb.
      <br />
      <br />
      Setiap dari kita pasti pernah mengalami momen atau fase tersebut dan itu
      wajar. Yang kamu butuhkan hanyalah pertolongan dari orang yang mengerti
      dan bisa membantu menghilangkan rasa itu dari dalam pikiran kamu, yakni
      pikiran bawah sadar kamu.
      <br />
      <br />
      Mengapa dikatakan pikiran bawah sadar? Pikiran manusia dibagi menjadi 2
      bagian ada pikiran sadar dan pikiran bawah sadar, pikiran sadar manusia
      memiliki peran hanya sekitar 10-15%dari pola pikir dan bagaimana kita
      mengambil keputusan dan bagaimana kita bertindak. Sisanya sekitar 85-90%
      dikendalikan oleh pikiran bawah sadar kita.
      <br />
      <br />
      Sehingga pasti ada momen di dalam hidup kamu dimana kamu merasa gagal,
      stress berat ,depresi, insecure dan overthinking segala cara sudah kamu
      tempuh untuk bisa menghilangkan rasa itu, dengan menemui psikolog,
      berbicara dan bertukar pikiran dengan sahabat, orang terdekat, atau pemuka
      agama, namun tetap saja kamu tidak dapat keluar dari perasaan - perasaan
      negatif tadi.
      <br />
      <br />
      kamu secara sadar tahu bahwa rasa itu tidak baik, rasa itu membuat hidup
      kamu nelangsa, tapi kamu secara tidak sadar memilih untuk tetap di fase
      itu dan sulit untuk keluar.
      <br />
    </>
  ),
  titleC1: "Ada sebuah cerita yang mungkin mewakilkan kisah kamu sekarang:",
  C1: [
    {
      A: `A: (sambil menangis) "sist, aku cape sama pacarku dia kasarin aku lagi, aku seperti sudah tidak dianggap sedikit saja aku berbicara dia akan marah, kadang main tangan. Aku cape sist... aku harus bagaimana?"`,

      B: `B: "kan aku udah bilang, gak worthed kamu pertahankan hubungan kamu itu udah gak sehat, kamu harus mulai pikirin diri kamu sendiri, emang kamu bahagia engga kan?"`,
    },
    {
      A: `A: (masih menangis) "Ya engga, tapi aku takut kehilangan dia sist, aku masih sayang, walau kadang aku kepikiran juga buat putus karna aku memang merasa tertekan juga."`,

      B: `B:"Nah, kan ngapain jalanin hubungan. Kalo harus tertekan?"`,
    },
    {
      A: `A: "Iya sih, bener, aku coba ya semoga aku bs lupain dia"`,

      B: ` 
      (Dua minggu kemudia, B menghubungi A kembali untuk menanyakan kabar)
      B:"Sist apa kabar? Kamu gimana, udah putus sama dia?"`,
    },
    {
      A: `A: "Hi sist, engga sist aku masih sama dia, sebenarnya aku udah cape sist tapi rasanya aku g bs pisah dr dia."`,

      B: `B: (Sambil marah) "Ckckckckck, gak habis pikir aku sama kamu ya, lama-lama aku yang cape nemenin kamu curhat sampe pagi mulu tapi saranku g pernah didengerin, terserah kamu deh tp kalo kenapa -kenapa, gak usah hubungin aku lagi ya".`,
    },
    {
      A: `
      (Sampai satu saat, A mendapatkan saran dari seseorang untuk mengikuti terapi hypno, dan setelah 3 kali sesi, ia pun berbicara dengan terapisnya)
      A: "Mba,kok aku sekarang lebih plong yah, lebih relaks. Kemarin akhirnya aku putuskan hubunganku dengan dia, dan aku tidak merasa berat sama sekali. Beban itu bagaikan hilang. Padahal aku kemarin bertahan sama dia pacaran 5 thn, walau batin tersiksa tapi saya pilih bertahan gak tahu kenapa".`,

      B: `B: "Ya, memang itulah gunanya hipnoterapi, kita bersihkan sampah pikiran yang membebani diri kamu selama ini yang telah menyebabkan  kamu cenderung mengambil keputusan-keputusan yang salah dan tidak menguntungkan bagi kamu. Nilai- nilai yang merugikan kamu yang tersimpan di alam bawah sadar kamu itu yang kita bersihkan dan kita hilangkan, kita ganti dengan nilai nilai baru yang lebih menguntungkan dan membantu kamu untuk bisa mengambil kelutusan tepat bagi diri kamu."`,
    },
    {
      A: `A: "Ya benar mba, walau aku sadar itu salah tapi aku selalu mengambil keputusan yg sebenarnya aku gak suka tanpa aku jg tahu penyebabnya. Tapi sekarang aku sudah plong mba. Makasih ya".`,
    },
  ],
  c2: (
    <>
      HIPNOTERAPI membantu kamu untuk bisa membuang sampah saplah pikiran atau
      nilai-nilai yang tidak menguntungkan bagi kamu yang tersimpan di alam
      bawah sadar kamu.
      <br />
      <br />
      Bagaimana caranya? Sebagaimana arti dari kata hypno, sendiri adalah
      membawa kepada kondisi relaks. Rileks yang dimaksud adalah membuat seluruh
      tubuh khususnya pikiran sadar ke arah kondisi yang sangat relaks, sehingga
      mudah untuk mengaktifkan pikiran bawah sadar dan me-resetnya kembali.
      <br />
      <br />
      Sebagaimana seperangkat komputer, tubuh kita adalah hardware dan pikiran
      kita adalah software.
      <br />
      <br />
      Software perlu di update atau bahkan direset atau diinstal operating
      system terbaru agar tetap produktif. Karena software yang corrupt,
      performa komputer secara keseluruhan juga akan sering bermasalah.,
      sebagaimana pikiran, pikiran yang corrupt bisa berakibat pada performa
      tubuh kita yang terganggu, mungkin terkena penyakit, atau gampang stress,
      gampang pusing, dan berbagai gejala penyakit fisik lainnya.
      <br />
      <br />
      Melalui terapi hypno, memudahkan untuk mengganti software yang sudah tdk
      bekerja dengan baik dengan software terbaru, sehingga kamu bisa menjadi
      versi terbaik dari diri kamu dalam waktu yang lebih singkat tanpa obat
      keras.
    </>
  ),
};

const sectionDataID2 = {
  image: Post2,
  title: "Management Amarah",
  opening: (
    <>
      Masalah Mengendalikan Emosi sering berasal dari pengalaman masa lalu.
      Pengalaman-pengalaman ini dapat membentuk perilaku dan sistem kepercayaan
      Anda. Jadi, meskipun Anda mungkin berpikir orang atau situasi lain yang
      menyebabkan kemarahan Anda, itu mungkin berasal dari diri Anda sendiri.
      Setelah ini dipahami, hipnoterapis Anda dapat mulai bekerja mengubah ini.
      <br />
      <br />
      Untuk melakukannya, hipnoterapi Anda akan bekerja pada tingkat Alam bawah
      sadar untuk membantu mengubah proses pemikiran negatif Anda. Melakukan hal
      ini mungkin melibatkan teknik relaksasi dan saran dari terapis Anda untuk
      membantu mengendalikan kemarahan Anda.
      <br />
      <br />
      Harapannya adalah ini akan mengubah reaksi Anda terhadap pemicu kemarahan.
      Alih-alih merasa kewalahan dan marah, Anda harus merasa lebih tenang dan
      lebih rileks. Merasa lebih tenang dalam situasi stres membantu Anda untuk
      berpikir lebih jernih sehingga Anda dapat bereaksi dengan cara yang lebih
      tepat.
      <br />
      <br />
      Hipnoterapi manajemen Amarah juga dapat membantu dengan beberapa gejala
      kemarahan. Misalnya, jika Anda menderita kecemasan, stres atau depresi,
      hipnoterapi dapat membantu.
      <br />
    </>
  ),
  titleC1: "Tips Mengendalikan Emosi:",
  c1: (
    <>
      1. Kenali pemicunya
      <br />
      Memahami situasi apa yang membuat Anda merasa marah adalah kuncinya.
      Dengan mengenali kapan Anda cenderung merasa marah, Anda bisa bersiap.
      Untuk melakukan ini, mulailah membuat catatan ketika Anda merasa marah.
      Coba perhatikan hal-hal berikut:
      <br />
      <br />
      <ul className="list-disc pl-10 space-y-2">
        <li>Apa situasinya?</li>
        <li>Apakah ada orang lain yang terlibat?</li>
        <li>
          Apa yang mereka katakan/lakukan untuk membuat Anda merasa marah?
        </li>
        <li>Bagaimana perasaan Anda saat itu?</li>
        <li>Bagaimana Anda berperilaku?</li>
        <li>Bagaimana perasaan Anda setelah kejadian itu?</li>
      </ul>
      <br />
      Setelah beberapa saat, Anda akan mulai memperhatikan beberapa pola yang
      muncul. Mungkin Anda marah ketika Anda merasa diremehkan, atau mungkin
      Anda merasa lebih marah setelah situasi tersebut karena Anda tidak dapat
      mengekspresikan diri Anda saat itu.
      <br />
      <br />
      Bicarakan catatan Anda dengan hipnoterapis Anda, karena ini dapat membantu
      mereka bekerja dengan Anda untuk memahami alasan yang mendasari kemarahan
      Anda. Mengenali pola-pola ini saja bisa sangat membantu.
    </>
  ),
  c2: (
    <>
      2. Beri diri Anda waktu
      <br />
      Cara sederhana untuk membantu Anda mengelola kemarahan saat situasi pemicu
      muncul adalah dengan memberi diri Anda waktu sebelum bereaksi. Ini
      memungkinkan Anda untuk benar-benar memikirkan bagaimana Anda bereaksi,
      daripada bereaksi secara naluriah. Coba saran berikut untuk melihat apakah
      itu membantu:
      <br />
      <br />
      <ul className="list-disc pl-10 space-y-2">
        <li>
          Ambil napas dalam-dalam - bernapas lebih lama dari yang Anda hirup
          dapat membantu menenangkan Anda.
        </li>
        <li>
          Hitung sampai 10 - tindakan sederhana yang dapat memberi Anda cukup
          waktu untuk menenangkan diri sebelum bereaksi.
        </li>
        <li>
          Lakukan sesuatu yang lain - alih-alih bereaksi, cobalah mengalihkan
          perhatian Anda dengan melakukan sesuatu yang lain. Kalau bisa, coba
          salurkan energi itu menjadi sesuatu yang kreatif.
        </li>
        <li>
          Dengarkan musik/suara yang menenangkan - buat daftar putar yang
          menenangkan dan dengarkan saat Anda mulai merasa marah.
        </li>
      </ul>
      <br />
      Cobalah beberapa teknik pengalih perhatian yang berbeda dan lihat apa yang
      paling cocok untuk Anda. Sekali lagi, ini adalah sesuatu yang dapat Anda
      diskusikan dengan hipnoterapis Anda karena mereka mungkin memiliki
      beberapa saran alternatif.
    </>
  ),

  c3: (
    <>
      3. Cobalah beberapa teknik relaksasi
      <br />
      Stres dan kemarahan cenderung berjalan beriringan. Banyak orang menemukan
      bahwa mengurangi tingkat stres membantu mereka mengendalikan amarah.
      Teknik relaksasi menantang aspek fisik dari stres dan kemarahan. Ini dapat
      membantu Anda menahan diri untuk tidak menyerang atau berperilaku kasar
      saat Anda marah. Cobalah beberapa teknik berikut saat Anda merasa stres:
      <br />
      <br />
      <ul className="list-disc pl-10 space-y-2">
        <li>Meditasi</li>
        <li>Visualisasi</li>
        <li>Yoga</li>
        <li>Latihan pernapasan</li>
      </ul>
      <br />
      Salah satu cara hipnoterapi untuk kemarahan dapat membantu adalah dengan
      memicu respons relaksasi tubuh. Selama sesi hipnoterapi, Anda akan jatuh
      ke dalam keadaan sangat santai. Pada titik inilah hipnoterapis menawarkan
      saran untuk membantu mengendalikan kemarahan Anda.
    </>
  ),
};

const sectionDataID3 = {
  image: Post3,
  title: "Fobia",
  titleC1: "Apa Itu Fobia?",
  c1: (
    <>
      Fobia adalah ketakutan irasional dan berlebihan terhadap aktivitas,
      situasi, atau objek tertentu yang memicu keinginan kuat untuk menghindari
      hal itu. Jika seseorang memiliki fobia, bagi orang lain mungkin tampak
      konyol, tetapi bagi orang yang memiliki fobia itu adalah ketakutan yang
      sebenarnya. Memiliki fobia ini bukan kesalahan mereka dan bukan sesuatu
      yang bisa mereka "lupakan".
      <br />
      <br />
      Cara lain untuk melihat fobia adalah sebagai respons otomatis yang tidak
      disadari terhadap stimulus, yang berasal dari persepsi yang salah tentang
      stimulus tersebut. Para ilmuwan mengatakan bahwa hanya dua ketakutan yang
      turun-temurun atau naluriah alami: takut jatuh dan takut suara keras.
      Segala sesuatu yang lain dipelajari. Kabar baiknya adalah, itu berarti itu
      bisa tidak dipelajari.
      <br />
      <br />
      Fobia biasanya dimulai saat kita masih muda. Namun, pengalaman traumatis
      apa pun yang kita alami, seperti kecelakaan atau cedera serius, dapat
      menyebabkan fobia di masa dewasa.
      <br />
      <br />
      Ada dua kategori utama fobia:
    </>
  ),
  c2: (
    <>
      <br />
      <strong>Fobia Sosial</strong> – ketakutan yang melibatkan orang lain atau
      situasi seperti:
      <br />
      <br />
      <ul className="list-disc pl-10 space-y-2">
        <li>Berbicara di depan umum</li>
        <li>Kecemasan kinerja</li>
        <li>Malu di depan umum, seperti makan</li>
        <li>
          Fobia sosial umum, yang dikenal sebagai gangguan kecemasan sosial
        </li>
        <li>
          Fobia sosial spesifik, yaitu kasus kecemasan yang dipicu hanya dalam
          situasi tertentu seperti tidak dapat buang air kecil di kamar mandi
          umum
        </li>
      </ul>
      <br />
      <strong>Fobia spesifik</strong> – ketakutan akan satu pemicu panik
      tertentu seperti:
      <br />
      <br />
      <ul className="list-disc pl-10 space-y-2">
        <li>Laba-laba</li>
        <li>Anjing</li>
        <li>Lift</li>
        <li>Air</li>
        <li>Penerbangan</li>
        <li>Kematian</li>
        <li>Banyak, banyak lagi</li>
      </ul>
      <br />
      Fobia dapat menjadi parah pada beberapa individu sementara yang lain hanya
      dapat menghindari pemicu ketakutan mereka dan memiliki kecemasan ringan
      atas ketakutan itu. Kebanyakan memahami bahwa mereka menderita ketakutan
      irasional, tetapi mereka merasa tidak berdaya untuk dapat mengatasi reaksi
      panik naluriah mereka.
    </>
  ),
  titleC3: "Apa 10 Fobia Paling Umum?",
  c3: (
    <ul className="list-decimal pl-10 space-y-2">
      <li>Arachnophobia – takut pada laba-laba.</li>
      <li>
        Fobia Sosial – ketakutan akan dievaluasi secara negatif dalam situasi
        sosial seperti berbicara di depan umum.
      </li>
      <li>Aerophobia – takut terbang.</li>
      <li>
        Agoraphobia – ketakutan akan tempat atau situasi di mana sulit untuk
        melarikan diri.
      </li>
      <li>
        Claustrophobia – takut terjebak di ruang terbatas kecil seperti lorong
        atau lift.
      </li>
      <li>Acrophobia – takut ketinggian.</li>
      <li>Emetophobia – takut muntah.</li>
      <li>Carcinophobia – ketakutan akan kanker.</li>
      <li>Brontophobia – takut akan guntur dan kilat.</li>
      <li>Necrophobia – ketakutan akan kematian.</li>
    </ul>
  ),

  titleC4: "Mengakhiri Hidup yang Penuh Ketakutan Irasional adalah Mungkin",

  c4: (
    <>
      Ada harapan. Fobia dapat diobati. Tetapi ketika pemicu rasa takut dapat
      dengan mudah dihindari (sebagian besar), seseorang mungkin memutuskan
      untuk mencoba dan mengabaikannya daripada pergi berobat. Hal ini dapat
      menyebabkan fobia terwujud dan menyebabkan gangguan dalam kehidupan
      seseorang di masa depan. Fobia dapat muncul tanpa pemicu atau alasan dan
      mungkin sulit untuk diobati dengan teknik psikoterapi standar.
      <br />
      <br />
      Banyak hipnoterapis mungkin menggunakan "Terapi Bagian" sebagai pengobatan
      untuk menemukan bagian dari diri Anda yang memiliki fobia. Terapi bagian
      didasarkan pada gagasan bahwa kepribadian kita terdiri dari sejumlah
      bagian yang berbeda yang merupakan aspek alam bawah sadar, masing-masing
      dengan fungsi masing-masing dalam alam bawah sadar.
      <br />
      <br />
      Kembalikan bagian diri Anda itu, bagian dari kepribadian Anda, ke saat
      pertama kali Anda menyadari penyebab fobia saat ini. Berbagai teknik
      hipnoterapi dapat membantu membuat Anda tidak peka, membingkai ulang momen
      awal tentang rasa takut, yang memungkinkan Anda untuk berfungsi secara
      bebas tanpa rasa takut. Anda mungkin akan diperkenalakan teknik
      self-hypnosis untuk membantu memperkuat kehidupan bebas fobia Anda.
    </>
  ),
};

const sectionDataID4 = {
  image: Post4,
  title: "Terapi Pasangan",
  opening: (
    <>
      Penyebab paling umum dari pertengkaran pasangan:
      <br />
      <br />
      <ul className="list-decimal pl-10 space-y-2">
        <li>Keuangan</li>
        <li>Menjadi Orang Tua / Anak</li>
        <li>Tugas rumah</li>
        <li>Perselingkuhan</li>
        <li>Terlalu Protektif / Cemburu</li>
        <li>Karier</li>
        <li>Mendengkur dan kebiasaan tidur lainnya</li>
      </ul>
      <br />
      Bahkan Hal Sederhana Seperti Meninggalkan Handuk Basah Dapat Memicu
      Ketegangan Dalam Suatu Hubungan. <br />
      Kapan Pasangan Harus Pergi Ke Terapi Bersama Untuk Menyelesaikan Konflik?
    </>
  ),
  titleC1: `Tanda-tanda Anda harus pergi ke terapi pasangan:`,
  c1: (
    <>
      <ul className="list-disc pl-10 space-y-2">
        <li>Komunikasi yang buruk dengan pasangan Anda</li>
        <li>Perasaan bosan atau mati rasa tentang hubungan Anda</li>
        <li>Ingin belajar bagaimana memiliki konflik yang sehat</li>
        <li>Memiliki pertarungan yang sama berulang-ulang tanpa resolusi</li>
        <li>Keinginan untuk meningkatkan hubungan Anda</li>
        <li>Merasa jauh dari pasangan</li>
        <li>
          Merasa seperti Anda tidak mendapatkan sesuatu yang Anda butuhkan
          (misalnya, waktu atau kasih sayang)
        </li>
        <li>
          Menangani peristiwa besar dalam hidup (seperti pindah, pekerjaan baru,
          atau keputusan sulit)
        </li>
        <li>Mengelola transisi dari pasangan menjadi orang tua baru</li>
        <li>Mengelola transisi dari menjadi orang tua ke sarang kosong</li>
        <li>Kehadiran pengkhianatan (perselingkuhan atau ketidaksetiaan)</li>
        <li>
          Mempertimbangkan perceraian atau bertanya-tanya apakah Anda harus
          putus
        </li>
        <li>
          Keinginan untuk meletakkan dasar yang kuat sebelum menikah (konseling
          pranikah)
        </li>
        <li>Merasa terlalu terikat satu sama lain (kodependensi)</li>
        <li>Kehadiran trauma masa lalu yang muncul dalam hubungan Anda</li>
      </ul>
    </>
  ),

  c2: (
    <>
      Dengan hipnosis, sudut pandang kedua pasangan dapat diubah untuk
      memungkinkan penyembuhan konflik mereka dan menjadi hubungan yang sehat
      dan positif.
      <br />
      <br />
      Penggunaan hipnoterapi pasangan dapat memungkinkan kedua pasangan untuk
      mengevaluasi kembali peristiwa besar, untuk melihat sesuatu dari
      perspektif yang berbeda, dan untuk mendapatkan lebih banyak rasa hormat
      masing-masing. Hipnosis dapat membantu memikat kembali perasaan cinta,
      romansa, komitmen, dan persahabatan yang hilang, sehingga memungkinkan
      kembalinya keharmonisan pasangan.
    </>
  ),
};

const sectionDataID5 = {
  image: Post5,
  title: "Hipnoslimming",
  opening: (
    <>
      Anda bisa tetap makan makanan/minuman favorit Anda tanpa khawatir akan
      membuat Anda gemuk. tidak percaya?
      <br />
      <br />
      Hipnoslimming mengUbah Pola Pikir Anda Untuk Menurunkan Berat Badan Tanpa
      Diet Ketat. Ini hanya mengubah program yang salah di pikiran Anda. Selama
      ini sudah tertanam dalam pola pikir kita bahwa makan banyak bisa membuat
      kita gemuk. Padahal sebenarnya kita tetap bisa diet dengan perut kenyang.
      <br />
      <br />
      Berlawanan dengan cara diet lain yang fokus pada asupan kalori, metode
      hypnoslimming menggunakan teknik Neuro Linguistic Programming (NLP) untuk
      membantu akar masalah psikometrik di alam bawah sadar. Hipnoslimming
      dirancang untuk menanamkan pemikiran dan perilaku yang lebih positif,
      sehingga Anda dapat memisahkan makanan dari kehidupan emosional. Alhasil,
      Anda menjadi lebih disiplin dalam berolahraga, tidak lagi merasakan
      keinginan untuk sering ngemil, dan secara sadar memilih pola makan yang
      lebih sehat meski tidak mengikuti pola diet tertentu.
    </>
  ),

  titleC1: "Kisah Sukses Menurunkan Berat Badan dengan Hypnoslimming",

  c1: (
    <>
      Salah satu presenter wanita terkenal di Indonesia, Dewi Hughes yang telah
      membuktikan bahwa ia kehilangan 80 kg dalam 15 bulan!
      <br />
      <br />
      Menurutnya, jika Anda hanya ingin kurus, Anda akan melakukan segala
      kemungkinan tanpa berpikir. Misalnya, Anda sibuk membuat daftar makanan
      yang Anda makan dan yang tidak boleh, batasan kalori, porsi, dan frekuensi
      berapa kali Anda memakannya.
      <br />
      <br />
      Dewi Hughes menggunakan metode hipnoterapi sesuai dengan kemampuannya agar
      proses diet yang dijalaninya berjalan dengan konsisten dan maksimal.
      Hipnoslimming telah meluruskan pola pikirnya dengan mengubah tujuannya
      untuk hidup lebih sehat daripada hanya sekedar kurus. Ia juga mengatakan,
      tekad untuk menurunkan berat badan tidak boleh datang karena keinginan
      menjadi kurus.
    </>
  ),
};

const sectionDataID6 = {
  image: Post6,
  title: "Kecanduan (Rokok, Narkoba, Alkohol, DLL.)",
  openingTitle: "Bisakah Hipnosis Menyembuhkan Kecanduan?",
  opening: (
    <>
      Penelitian telah menunjukkan bahwa hipnosis dapat efektif dalam mengobati
      beberapa kondisi medis. Sementara hipnosis untuk berhenti minum (ALKOHOL)
      atau berhenti menggunakan narkoba dapat menjadi alat perilaku yang
      efektif, hipnoterapi untuk alkoholisme dan/atau kecanduan narkoba bahkan
      bisa lebih membantu. Hipnoterapi menggabungkan dua modalitas pengobatan -
      hipnosis dan psikoterapi.
      <br />
      <br />
      Selain membantu orang lebih memahami kecanduan mereka, itu juga dapat
      membantu pasien lebih mungkin untuk tetap dalam program perawatan,
      menghadiri pertemuan, dan bekerja dengan sponsor. Singkatnya: itu dapat
      membuat pasien lebih bersedia dan menerima berbagai elemen dari rangkaian
      perawatan kecanduan.
      <br />
      <br />
      Selanjutnya, sifat penghilang rasa sakit hipnosis juga dapat digunakan
      untuk mengurangi hambatan fisik untuk pemulihan, termasuk gejala seperti
      penarikan, kecemasan, ketegangan otot, kejang, dan nyeri.
      <br />
      <br />
      Satu hal terakhir yang perlu diingat? Terlepas dari potensinya, hipnosis
      bukanlah peluru ajaib. Tidak ada satu sesi pun yang akan mengarah ke
      perbaikan instan. Juga tidak efektif untuk semua orang. Namun, ini dapat
      menjadi alat yang efektif yang bagi bagian orang dapat digunakan untuk
      proses mengatasi kompleksitas dan tantangan kecanduan.
    </>
  ),
};

const sectionDataID7 = {
  image: Post7,
  title: "Hipnosis luka di masa Anak-Anak",
  openingTitle: "Sembuhkan luka masa Anak-Anak Anda melalui Hipnosis",
  opening: (
    <>
      Tanpa disadari, sebagian besar perilaku dan kepribadian orang dewasa saat
      ini adalah hasil dari bagaimana masa kanak-kanak seseorang. Banyak kasus
      menunjukkan bahwa pengalaman buruk di masa kecil membuat seseorang tumbuh
      menjadi Dewasa yang pengecut, minder, keras kepala, ketakutan, atau bahkan
      perilaku menyimpang lainnya.
      <br />
      <br />
      Dalam sesi penyembuhan luka masa Anak-Anak, terapis akan membuat cerita
      metaforis untuk perubahan. Dimana anda versi anak-anak dapat
      mengeksplorasi dirinya dan menjadi dewasa. Sebuah cerita yang dapat
      memberdayakan anak dan memungkinkan aliran bebas berekspresi dan
      berkreasi. Aspek bawah sadar dari diri sejati adalah kreatif dan tidak
      tahu perbedaan antara fakta dan fantasi.
      <br />
      <br />
      Jadi melepaskan dan memercayai pikiran bawah sadar untuk menerima cerita
      baru sebagai nyata adalah penting. Satu-satunya hal yang menghalangi
      adalah kemampuan kritis dari pikiran analitis. Yang perlu kita lakukan
      adalah memerintahkannya untuk menyingkir dan membiarkan penyembuhan
      terjadi.
    </>
  ),
};

const sectionDataID8 = {
  image: Post8,
  title: "Berhenti Merokok",
  opening: (
    <>
      Meskipun bukti ilmiah terbatas mengenai efektivitasnya, hipnoterapi
      populer sebagai alat untuk berhenti merokok. Namun, tidak jelas apakah
      hipnosis memperkuat keinginan untuk menghentikan kebiasaan atau justru
      menurunkan keinginan untuk melanjutkan (Barnes, McRobbie, Dong, Walker, &
      Hartmann-Boyce, 2019).
      <br />
      <br />
      Dalam ulasan 2019 mereka termasuk 14 studi dan 1.926 peserta, Barnes DKK.
      menemukan intervensi hipnoterapi sama efektifnya dengan bentuk dukungan
      perilaku lainnya enam bulan setelah perawatan Rehabilitasi.
    </>
  ),
};

const sectionDataID9 = {
  image: Post9,
  title: "Hipnoterapi Insomnia",
  opening: (
    <>
      Insomnia merupakan suatu keadaan ketika seseorang mengalami kesulitan
      untuk tidur atau tidak dapat tidur dengan nyenyak, sering terjaga saat
      tidur, sulit memulai tidur, dan bahkan tidak bisa mencapai kualitas tidur
      yang normal. Insomnia paling sering terjadi pada lansia yang dipengaruhi
      oleh faktor usia, gaya hidup, lingkungan, dan pola makan.
      <br />
      <br />
      Hipnoterapi insomnia kini banyak dimanfaatkan sebagai metode pengobatan
      salah satunya sebagai pengobatan untuk penyembuhan penderita insomnia.
      Hipnoterapi insomnia bekerja dengan cara memasuki alam bawah sadar
      seseorang, lalu memberikan sugesti tertentu untuk membantu proses
      penyembuhan. Prevalensi insomnia pada lansia tahun 2014 di indonesia
      sekitar 10%. Pada tahun 2015 sekitar 15% dan pada tahun 2016 sekitar 17%
      artinya kurang lebih 28 juta dari total 238 juta penduduk indonesia
      menderita insomnia. ( Dinkes, 2019).
      <br />
      <br />
      Keadaan relaksasi setelah dilakukan hipnosis dapat meningkatkan rasa
      kenyamanan Klien saat berada di tempat tidur, sehingga Klien dengan mudah
      dapat tertidur, pikiran yang rileks mengurangi timbulnya mimpi, menurunkan
      frekuensi terbangun dan meningkatkan total waktu tidur malam. Selain
      faktor hipnoterapi, terapis juga memberikan pelatihan self hypnosis pada
      klien, self hypnosis merupakan hipnosis diri yang dapat membantu klien
      mencapai keadaan rileks tanpa dibantu oleh terapis.
    </>
  ),
};

const sectionDataID10 = {
  image: Post10,
  title: "Apakah Hipnoterapi Benar-Benar Berhasil?",
  opening: (
    <>
      Sementara beberapa ilmuwan masih menganggap hipnosis dengan
      ketidakpercayaan, Kini telah terbukti Hipnosis berguna dalam pengaturan
      klinis dan wawasan dalam penelitian proses mental seperti "sensasi,
      persepsi, pembelajaran, memori, dan fisiologi" (Faymonville et al., 2006).
      <br />
      Hipnosis dipandang sebagai keadaan perhatian, konsentrasi, dan penyerapan
      batin yang meningkat, dengan berkurangnya kesadaran terhadap rangsangan
      eksternal.
      <br />
      bagaimanapun, Hipnosis membutuhkan tiga komponen (Faymonville et al.,
      2006):
      <br />
      <br />
      <ul className="list-disc pl-10 space-y-4">
        <li>
          Penyerapan – untuk sepenuhnya terlibat dalam pengalaman imajinatif
        </li>
        <li>
          Disosiasi – pemisahan komponen perilaku yang biasanya diproses
          bersama, seperti menjadi aktor dan pengamat
        </li>
        <li>
          Sugestibilitas – peningkatan kecenderungan untuk “mematuhi instruksi
          hipnosis”
        </li>
      </ul>
      <br />
      <br />
      Sementara hipnoterapi tampak menjanjikan sebagai pengobatan untuk berbagai
      masalah yang menentukan kesehatan fisik dan psikologis, banyak penelitian
      tampaknya cacat karena desain percobaan yang buruk. Oleh karena itu,
      penelitian berkualitas tinggi lebih lanjut diperlukan untuk lebih memahami
      potensinya untuk meningkatkan nyeri kronis, depresi, gangguan tidur, dan
      gangguan makan (Chamine dkk., 2018).
      <br />
      <br />
      Jadi, apakah hipnoterapi benar-benar berhasil?
      <br />
      <br />
      Ya, ilmu pengetahuan telah mengkonfirmasi bahwa hipnoterapi dapat mengubah
      persepsi dan perilaku kita.
    </>
  ),
};

export {
  sectionDataID1,
  sectionDataID2,
  sectionDataID3,
  sectionDataID4,
  sectionDataID5,
  sectionDataID6,
  sectionDataID7,
  sectionDataID8,
  sectionDataID9,
  sectionDataID10,
};
